export default __webpack_public_path__ + "static/media/AVAT_Logo_Standard_4C_positiv.93ffb506.svg";